<template>
  <div v-if="showPrice" class="offer-original-price" :style="customStyle">
    {{ formattedPrice }}
  </div>
</template>

<script>
export default {
  name: "OfferOriginalPrice",
  props: {
    package: {
      type: Object,
      required: true,
    },
    displayConfig: {
      type: Object,
      default: null,
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    oldPrice() {
      // First check display_config, fallback to old payload location
      return this.displayConfig?.old_price || this.package?.payload?.old_price;
    },
    showPrice() {
      return this.oldPrice && this.package?.sku?.prices?.length > 0;
    },
    formattedPrice() {
      if (!this.showPrice) return "";

      const webPrice = this.package.sku.prices.find(
        (p) => p.platform === "web"
      );
      if (!webPrice) return "";

      const currencySymbols = {
        EUR: "€",
        USD: "$",
        GBP: "£",
      };
      const symbol = currencySymbols[webPrice.currency] || webPrice.currency;

      const n = Number(this.oldPrice);
      if (!Number.isFinite(n)) return `${this.oldPrice}${symbol}`;

      const raw = this.$store?.state?.locale || "de";
      const locale = raw === "de" ? "de-DE" : "en-US";

      const formatted = new Intl.NumberFormat(locale, {
        useGrouping: false,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);

      return `${formatted}${symbol}`;
    },
  },
};
</script>

<style scoped lang="scss">
.offer-original-price {
  position: absolute;
  color: #fff;
  text-align: center;
  font-weight: bold;
  text-decoration: none;
  z-index: 5;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 5%;
    width: 90%;
    height: 4px;
    background: #ff0000;
    transform: translateY(-50%) rotate(-10deg);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }
}
</style>
